import { createContext, useEffect, useState } from "react";
import { parseCookies } from "nookies";
import { useQuery } from "@apollo/client";
import fetchMe from "../lib/queries/fetchMe";

export const AppContext = createContext({ isAuthorized: false });